module.exports = __webpack_public_path__ + "static/media/qlik.b8efa557.svg";